import { render } from "./editor-viewer.vue?vue&type=template&id=15bc1ffd&scoped=true"
import script from "./editor-viewer.vue?vue&type=script&lang=js"
export * from "./editor-viewer.vue?vue&type=script&lang=js"

import "./editor-viewer.vue?vue&type=style&index=0&id=15bc1ffd&lang=scss&scoped=true"
import "./editor-viewer.vue?vue&type=style&index=1&id=15bc1ffd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bc1ffd"]])

export default __exports__